<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Revelation</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<p class="FMTitle"><a id="page_xx">Abbreviations</a></p><a id="page_xx">
<table border="0" cellpadding="0" cellspacing="0" class="Table1" width="100%">
<tbody><tr>
<td class="table-left">ACCS</td>
<td class="table-left1">Ancient Commentary of Christian Scripture</td>
</tr>
<tr>
<td class="table-left"><i>ATR</i></td>
<td class="table-left1"><i>Anglican Theological Review</i></td>
</tr>
<tr>
<td class="table-left">BAGD</td>
<td class="table-left1">Walter Bauer, William F. Arndt, F. William Gingrich, and Frederick W. Danker, <i>A Greek-English Lexicon of the New Testament and Other Early Christian Literature</i> (Chicago: University of Chicago Press, 2nd edition, 1958)</td>
</tr>
<tr>
<td class="table-left">BCOT</td>
<td class="table-left1">Baker Commentary on the Old Testament</td>
</tr>
<tr>
<td class="table-left">BZNW</td>
<td class="table-left1">Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft</td>
</tr>
<tr>
<td class="table-left"><i>CBQ</i></td>
<td class="table-left1"><i>Catholic Biblical Quarterly</i></td>
</tr>
<tr>
<td class="table-left">CNT</td>
<td class="table-left1">Commentaire du Nouveau Testament</td>
</tr>
<tr>
<td class="table-left"><i>CTJ</i></td>
<td class="table-left1"><i>Calvin Theological Journal</i></td>
</tr>
<tr>
<td class="table-left">CTM</td>
<td class="table-left1">Calwer theologische Monographien</td>
</tr>
<tr>
<td class="table-left">ECNT</td>
<td class="table-left1">Exegetical Commentary of the New Testament</td>
</tr>
<tr>
<td class="table-left"><i>EDNT</i></td>
<td class="table-left1">Horst Balz and Gerhard Schneider, eds., <i>Exegetical Dictionary of the New Testament</i> (3 vols. Grand Rapids: Eerdmans, 1990-1993).</td>
</tr>
<tr>
<td class="table-left"><i>EQ</i></td>
<td class="table-left1"><i>Evangelical Quarterly</i></td>
</tr>
<tr>
<td class="table-left">EUSST</td>
<td class="table-left1">European University Studies</td>
</tr>
<tr>
<td class="table-left"><i>HTR</i></td>
<td class="table-left1"><i>Harvard Theological Review</i></td>
</tr>
<tr>
<td class="table-left">ICC</td>
<td class="table-left1">International Critical Commentary</td>
</tr>
<tr>
<td class="table-left"><i>Int</i></td>
<td class="table-left1"><i>Interpretation</i></td>
</tr>
<tr>
<td class="table-left"><i>JBL</i></td>
<td class="table-left1"><i>Journal of Biblical Literature</i></td>
</tr>
<tr>
<td class="table-left"><i>JETS</i></td>
<td class="table-left1"><i>Journal of the Evangelical Theological Society</i></td>
</tr>
<tr>
<td class="table-left">JPTS</td>
<td class="table-left1">Journal of Pentecostal Theology Supplement</td>
</tr>
<tr>
<td class="table-left"><i>JSNT</i></td>
<td class="table-left1"><i>Journal for the Study of the New Testament</i></td>
</tr>
<tr>
<td class="table-left">JSNTS</td>
<td class="table-left1">Journal for the Study of the New Testament Supplement</td>
</tr>
<tr>
<td class="table-left"><i>JTS</i></td>
<td class="table-left1"><i>Joournal of Theological Studies</i></td>
</tr>
<tr>
<td class="table-left">MBPS</td>
<td class="table-left1">Mellen Biblical Press Series</td>
</tr>
<tr>
<td class="table-left"><a id="page_xxi">NCCS</a></td>
<td class="table-left1">New Covenant Commentary Series</td>
</tr>
<tr>
<td class="table-left">NDT</td>
<td class="table-left1">Das Neue Testament deutsch</td>
</tr>
<tr>
<td class="table-left">NIBC</td>
<td class="table-left1">New International Bible Commentary</td>
</tr>
<tr>
<td class="table-left">NICNT</td>
<td class="table-left1">New International Commentary on the New Testament</td>
</tr>
<tr>
<td class="table-left"><i>NIDNTT</i></td>
<td class="table-left1">Colin Brown, ed., <i>New International Dictionary of New Testament Theology</i> (3 vols. Grand Rapids: Zondervan, 1975-78)</td>
</tr>
<tr>
<td class="table-left">NIGNT</td>
<td class="table-left1">New International Greek New Testament</td>
</tr>
<tr>
<td class="table-left"><i>NovT</i></td>
<td class="table-left1"><i>Novum Testamentum</i></td>
</tr>
<tr>
<td class="table-left"><i>NRT</i></td>
<td class="table-left1"><i>La nouvelle revue théologique</i></td>
</tr>
<tr>
<td class="table-left">NTM</td>
<td class="table-left1">New Testament Message</td>
</tr>
<tr>
<td class="table-left"><i>NTS</i></td>
<td class="table-left1"><i>New Testament Studies</i></td>
</tr>
<tr>
<td class="table-left">PTMS</td>
<td class="table-left1">Pittsburgh Theological Monograph Series</td>
</tr>
<tr>
<td class="table-left"><i>PTR</i></td>
<td class="table-left1"><i>Princeton Theological Review</i></td>
</tr>
<tr>
<td class="table-left">SBL</td>
<td class="table-left1">Society of Biblical Literature</td>
</tr>
<tr>
<td class="table-left">SNTSMS</td>
<td class="table-left1">Society for New Testament Studies Monograph Series</td>
</tr>
<tr>
<td class="table-left"><i>TDNT</i></td>
<td class="table-left1">Gerhard Kittel and Gerhard Friedrich, eds., <i>Theological Dictionary of the New Testament</i> (trans. Geoffrey W. Bromiley; 10 vols; Grand Rapids: Eerdmans, 1964-)</td>
</tr>
<tr>
<td class="table-left"><i>TynB</i></td>
<td class="table-left1"><i>Tyndale Bulletin</i></td>
</tr>
<tr>
<td class="table-left">WBC</td>
<td class="table-left1">Word Biblical Commentary</td>
</tr>
<tr>
<td class="table-left">WUNT</td>
<td class="table-left1">Wissenschaftliche Untersuchungen zum Neuen Testament</td>
</tr>
<tr>
<td class="table-left"><i>ZNW</i></td>
<td class="table-left1"><i>Zeitschrift für die neutestamentliche Wissenschaft</i></td>
</tr>
</tbody></table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?7ca7023e